import { useQuery, useQueryClient } from "react-query"
import { getUpdateDates, getUpdates } from "./updates"

export const updateDatesCacheKey = () => ["whatsNew", "dates"]
export const updatesCacheKey = () => ["whatsNew", "posts"]

// Once per session: new posts show on the next app load
const options = { staleTime: Infinity, cacheTime: Infinity }

export const useUpdateDates = () => useQuery(updateDatesCacheKey(), getUpdateDates, options)

export const useUpdates = () => useQuery(updatesCacheKey(), getUpdates, options)

export const usePrefetchUpdates = () => {
  const queryClient = useQueryClient()

  return () => queryClient.prefetchQuery(updatesCacheKey(), getUpdates, options)
}
